import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { TemplatesHttpClient } from './templates.http-client';
import { ReferralsTemplateActions } from './templates.store';

@Injectable({ providedIn: 'root' })
export class ReferralsTemplateEffects {
  public effects = createEffectFactory(ReferralsTemplateActions, this.actions$);

  public fetchCollection$ = this.effects(ReferralsTemplateActions.fetchCollection, () =>
    this.http.loadTemplates().pipe(map(data => ({ data }))),
  );

  public updatePositions$ = this.effects(ReferralsTemplateActions.updatePositions, ({ payload }) =>
    this.http.updateTemplatePositions(payload).pipe(
      map(() => ReferralsTemplateActions.updatePositionsSuccess()),
      catchError(error => of(ReferralsTemplateActions.updatePositionsFailed({ payload: error }))),
    ),
  );

  public refreshCollection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ReferralsTemplateActions.updatePositionsSuccess),
      switchMap(() => [ReferralsTemplateActions.fetchCollection()]),
    ),
  );

  constructor(
    private actions$: Actions,
    private http: TemplatesHttpClient,
  ) {}
}
